import { Button, Listbox, Option, type SelectionEvents, tokens } from '@fluentui/react-components';
import type { StoredSelectedItemsSchema } from '../../types.js';
import { useStyles } from './styles.js';

type DataFilterProps = {
    items: {
        id: string;
        label: string;
        indent?: number;
        children?: {
            id: string;
            label: string;
        }[];
    }[];
};

type DataTableHeaderCellListProps<TData extends DataFilterProps> = {
    data: TData;
    selectedItems: StoredSelectedItemsSchema;
    handleSelectionChange: (event: SelectionEvents, changeData: { selectedOptions: string[] }) => void;
    onApplyFilter: () => void;
};

export function DataTableHeaderCellList<TData extends DataFilterProps>({
    data,
    selectedItems,
    handleSelectionChange,
    onApplyFilter,
}: DataTableHeaderCellListProps<TData>) {
    const styles = useStyles();

    return (
        <>
            <Listbox
                className={styles.listbox}
                multiselect
                selectedOptions={selectedItems.current}
                onOptionSelect={handleSelectionChange}
            >
                {data.items.length <= 1 ? (
                    <div>Keine Ergebnisse</div>
                ) : (
                    data.items.map((item) => (
                        <Option
                            key={item.id}
                            className={styles.listboxOption}
                            value={item.id}
                            aria-label={item.label}
                            style={{
                                marginLeft: item.indent
                                    ? `calc(${item.indent} * ${tokens.spacingHorizontalL})`
                                    : undefined,
                            }}
                        >
                            {item.label}
                        </Option>
                    ))
                )}
            </Listbox>

            <div className={styles.listboxButton}>
                <Button appearance="outline" disabled={data.items.length <= 1} size="small" onClick={onApplyFilter}>
                    Filter anwenden
                </Button>
            </div>
        </>
    );
}
